module.exports = {"id":"227928","name":"Nélson Semedo","rating":"81","photo":"./data/images/photos/2/227928.png","club":{"name":"FC Barcelone","logo":"./data/images/clubs/FCBarcelone.png"},"positions":["DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NelsonSemedo0.json
// module id = 3158
// module chunks = 0